import { useState } from "react";
import { useTranslation } from "react-i18next";

import UpdateRecordButtonLayout from "../layout/UpdateRecordButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";
import { cloneDeep } from "lodash";

function MomSysOrderBuyerDetailUpdateImgButton(props) {

    const { t } = useTranslation();

    const { id, schema, grid, refresh, onSuccess, customizeErrorMsgCallback, onChangeStandardSchema, modifyFormDataCallback, ...others } = props;

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();
    const [modifiedSchema, setModifiedSchema] = useState();

    const onOpen = () => {

        if (grid) {

            setFormData({ ...(grid.selectedItems[0]) });

            let clonedSchema = cloneDeep ( onChangeStandardSchema ( schema, grid.selectedItems[0].standard ) );

            clonedSchema.formGroups.push("update");

            for (const column of clonedSchema.columns) {
        
                switch (column.name) {

                    case "t_size":
                    case "w_size":
                    case "l_size":
                    case "material":
                    case "modellingFile":
                        
                        column.formGroup = 2;
                        column.disabled = false;
                        
                        break;

                    case "orderBuyerCancel":
                    case "description":

                        column.formGroup = 2;
                        column.hideInForm = false;

                        break;
                        
                    default:

                        column.disabled = true;

                        break;
                }

            }

            setModifiedSchema ( clonedSchema );
    
        }

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onUpdateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        if (refresh) {
            
            refresh.refresh();
            
        }

    };

    return (

        <>
            <UpdateRecordButtonLayout id={id + "update-button"} onClick={onOpen} {...others} />
            <AutoFormDialog
                id={id + "update-dialog"}
                mode="edit"
                formId={id + "update-form"}
                title={schema ? t(`dialog.title.${schema.name}.update`) : ""}
                schema={modifiedSchema}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onUpdateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                modifyFormDataCallback={modifyFormDataCallback}
            />
        </>

    );
}

export default MomSysOrderBuyerDetailUpdateImgButton;

